import axios from 'axios';

const api = axios.create({ baseURL: '/api' });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('byldr_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('byldr_token');
      localStorage.removeItem('byldr_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
